import { create } from 'zustand';

/**
 * Konto tylko do aplikacji Staff (#82/#83). Ustawiane przez interceptor axiosa, gdy
 * backend odpowie 403 `staff_only`: claim w tokenie bywa nieaktualny do godziny po
 * zmianie, a backend sprawdza też lustro w dokumencie `users`.
 */
interface StaffOnlyStore {
  blocked: boolean;
  setBlocked: (blocked: boolean) => void;
}

export const useStaffOnlyStore = create<StaffOnlyStore>((set) => ({
  blocked: false,
  setBlocked: (blocked) => set({ blocked }),
}));

/** Kod błędu backendu dla konta staffOnly na endpoincie panelu. */
export const STAFF_ONLY_ERROR = 'staff_only';

type ErrorBody = { message?: unknown } | null | undefined;

export const isStaffOnlyError = (status: number | undefined, data: unknown): boolean => {
  const message = (data as ErrorBody)?.message;
  return status === 403 && message === STAFF_ONLY_ERROR;
};

export type StaffOnlyGateState = 'pass' | 'loading' | 'blocked';

/**
 * Decyzja bramki: zablokuj, gdy backend zwrócił 403 `staff_only` albo token zalogowanego
 * ma claim `staffOnly`; czekaj, dopóki claim bieżącego konta nie jest sprawdzony.
 */
export const resolveStaffOnlyGate = (params: {
  currentUid: string | null | undefined;
  claim: { uid: string; staffOnly: boolean } | null;
  blockedByApi: boolean;
}): StaffOnlyGateState => {
  if (!params.currentUid) return 'pass';
  if (params.blockedByApi) return 'blocked';
  if (params.claim?.uid !== params.currentUid) return 'loading';
  return params.claim.staffOnly ? 'blocked' : 'pass';
};
